<script>

    import { onDestroy, onMount, tick } from 'svelte';
	import { slide } from 'svelte/transition';
	import { quintOut } from 'svelte/easing';
	
    import { chatMessages } from '../../stores.js';
    import { Conference } from '../../Conference/Conference.js';
    import { Peers_Handler } from '../../Peers.js';
    import { resizeChatHeight } from "../ResizeChatHeight.js";
    import { two_col_mode } from "../../stores.js"


    export let handleClick;
    export let openChat = false;

	let messages = null;
	let newText = "";
    let sn = "";
	let isScrolledBottom = false;
	let lastScrollTop = 0;

    $: twoColMode = $two_col_mode;

    const name_unsub = Peers_Handler.self_peer.name.subscribe(n => sn = n);
	const onSubmit = async () => {

		if (newText === '')
			return;

		//let sn = get(screenName).trim(); 
		//sn === "Name?" ? sn = jitsiApi.jitsiConference.myUserId() : sn;

		const newMessage = {
			screenName: sn,
			text: linkifyStr(newText, { target: "_blank", className: "msgLink" })
		};

        const linkPos = newMessage.text.indexOf("<a");
        if (linkPos >= 0){
            newMessage.text = [newMessage.text.slice(0, linkPos + 2), ` style="color: #fdc6be" `, newMessage.text.slice(linkPos + 2)].join('');
        }

		Conference.sendChatMessage(newMessage);
		newMessage.local = true;

		renderMessage(newMessage);
		newText = '';
	
	}

	const checkIfScrolledBottom = () => {
		
        if (messages){
			const diff = Math.abs(messages.scrollHeight - messages.scrollTop);
			if (Math.abs(messages.clientHeight - diff) <= 5){
                isScrolledBottom = true;
                chatMessages.update(msgObject => {
                    msgObject.unread = 0;
                    return msgObject;
                })	
            }
						
		}
	}

	const updateScroll = async () => {
		await tick();
		if (messages && isScrolledBottom){
			messages.scrollTop = 4000000; //just a big number to force max scroll. Number.MAX_VALUE does not work
			lastScrollTop = messages.scrollTop;
		}
	}

    //this is called when we hit submit locally. Remote messages are added to the store and are rendered automatically
    //by that for loop inside of the svelte markup, which listens for changes
	const renderMessage = (newMessage) => {
		$chatMessages.msgs = [...$chatMessages.msgs, newMessage];
	}

    const onEnter = (e) => {
        if (e.keyCode === 13 && !e.shiftKey && !e.repeat){
            e.preventDefault();
            onSubmit();
        }
    };

    onMount(() => { 

        messages.scrollTop = 4000000;

		document.getElementById("txtArea").addEventListener("keydown", onEnter); 
        messages.addEventListener("scroll", e => {
			if (e.target.scrollTop < lastScrollTop)
				isScrolledBottom = false;
		});

        //sets the store unread value to 0
        chatMessages.update(msgObject => {
            msgObject.windowOpen = true;
            msgObject.unread = 0;
            return msgObject;
        })

        messages.addEventListener("scroll", (e) => {
            checkIfScrolledBottom();
        })
	})

    onDestroy(() => {
        chatMessages.update(msgObject => {
            msgObject.windowOpen = false;
            return msgObject;
        })
        name_unsub();
    })
	

</script>
        
<div class="chat-box" class:two-col={twoColMode} class:hidden={!openChat} use:resizeChatHeight={{ handleClick }}>
    <div class="message-box" bind:this={messages}>
      {#each $chatMessages.msgs as message}
        <div
          transition:slide|local={{ easing: quintOut }}
          on:introstart={checkIfScrolledBottom}
          on:introend={updateScroll}
          class={message.local ? "message local" : "message remote"}
        >
          <p id="message-name">{message.screenName + ":"}</p>
          <div class="message-content">{@html message.text}</div>
        </div>
      {/each}
    </div>
    <form class="message-form" id="form" on:submit|preventDefault={onSubmit}>
      <textarea id="txtArea" placeholder="Type a message" bind:value={newText} />
      <button class="btn:rounded icon" type="submit">
        <i id ="send-icon" class="fa-thin fa-arrow-right"></i>
      </button>
    </form>
  </div>
  
  <style lang="scss">

    @import "../styles/variables.scss";
    @import "../styles/main.scss";

    .hidden {
        display: none;
    }

    .chat-box {

        position: absolute;
        bottom: 60px;
        right: 0px;
        z-index: 10;       
        
        display: flex;
        flex-direction: column;
        
        gap: $gap-lg;
        padding: $gap-md;
        
        border-radius: $rounded-lg;
        background: rgb(10, 10, 10);
        border: 1px solid rgba(190, 157, 134, 0.08);
        box-shadow: 
            0 4px 24px -1px rgba(0, 0, 0, 0.3),
            inset 0 1px 1px rgba(255, 255, 255, 0.03);

        min-height: 300px; 
        max-height: 70%;       
        
        width: 100%;
        max-width: 520px;

      &.two_col {
        height: 60vh;
        min-height: 300px;
        bottom: 0px;
      }
    }
  
    :global(.grabber.top) {

        border-radius: $rounded-lg $rounded-lg 0 0;
        position: absolute;
        height: 26px;
        width: 100%;
        top: 0;
        left: 0;
        cursor: row-resize;
        background: linear-gradient(
            180deg,
            rgba(40, 43, 54, 0.1) 0%,
            rgba(25, 27, 34, 0.1) 100%
        );
        border-bottom: 1px solid rgba(190, 157, 134, 0.08);
        backdrop-filter: blur(8px);
    
        &:hover {
            background: linear-gradient(
                180deg,
                rgba(40, 43, 54, 0.5) 0%,
                rgba(25, 27, 34, 0.4) 100%
            );
        }
    
        &.selected {
            background: rgba(255, 255, 255, 0.2);
        }

    }

    :global(.grabber-content) {
        
        position: relative;
        
        display: flex;
        justify-content: center;
        align-items: center;
        
        height: 100%;
    }

    :global(#grabber-icon) {
        position: absolute;
        color: rgb(137, 133, 133);
        font-size: 2.4rem;
    }


    :global(#chat-close) {
        position: absolute;
        left: $gap-md;
        color: red;
        font-size: 1.8rem;
        cursor: pointer;
    }


    .message-box {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: $gap-sm;
        border-radius: $rounded-md;
        background: transparent;
        overflow-y: auto;
        margin-top: 10px;
        @include smoothScrollbar();
    }
  
    .message {

        max-width: 70%;
        align-self: flex-start;
        background: transparent;   //#adbcff1e  //e4adff1e
        color: $light-color;
        padding: $gap-sm;
        border-radius: calc($rounded-md * 2);

        // background: linear-gradient(180deg, #283341 0%, #192029 100%);
        // border-image-source: linear-gradient(180deg, #405166 0%, #0c1015 100%);
        // background: #b5adff1e;
        // background: transparent;
        //@include smoothScrollbar();

        &.local {
            align-self: flex-end;
            // background: linear-gradient(180deg, #42546a 0%, #303d4e 100%);
            // border-image-source: linear-gradient(180deg, #5b7392 0%, #222d3a 100%);
        }

        .message-content {
            font-size: $font-sm;
            line-height: 20px;

            overflow-wrap: break-word;     
            word-break: break-all;
            word-wrap: break-word;    
            
        }

        #message-name {
            color: rgb(137, 133, 133);
            padding-bottom: 1px;
            padding-top: 1px;
        }
    }
  
    .message-form {
        display: flex;
        background: linear-gradient(
            176deg,
            rgba(27, 26, 35, 0.1) 0%,
            rgba(24, 21, 21, 0.2) 100%
        );
        border: 1px solid rgba(190, 157, 134, 0.08);
        box-shadow: 
            0px 8px 16px 0px hsla(0, 0%, 0%, 0.15) inset,
            0 1px 1px rgba(255, 255, 255, 0.02);
        padding: $gap-sm;
        border-radius: $rounded-md;
  
        textarea {
            flex: 1;
            width: 100%;
            height: auto;
            color: $light-color;
            border: none;
            resize: none;
            overflow: auto;
            padding: 8px;
            background: transparent;
            font-family: inherit;
            line-height: 1.5;

            //I do like this color: rgba(190, 157, 134, 0.8);
            // &::placeholder {
            //     color: rgba(190, 157, 134, 0.4);
            // }

            &::-webkit-scrollbar {
                display: none;
            }
        }

        #send-icon {
            font-size: $font-sm;
            color: #97877e;
            transition: all 0.2s ease;
            padding-right: 3px;

            &:hover {
                color: rgba(190, 157, 134, 1);
                transform: translateX(2px);
            }
        }
    }
  

</style>
